import { GridItemProps } from "../../components/disposables/SequenceGridGames/GridItem";
import Layout from "../../layout/Layout";
import { RaftTypeE } from "../../types/raft";
import styles from "./styles.module.css";
import { useEffect } from "react";
import { VisitedScreenEnum } from "@robotical/appv2-analytics-gatherer/dist/types/types";
import SequenceGridGames from "../../components/disposables/SequenceGridGames";

import CarouselMaze from "../../assets/carousel-navigation/carousel-maze.png";
import CarouselSpaceShooter from "../../assets/carousel-navigation/carousel-space-shooter.png";
import CarouselCogShooter from "../../assets/carousel-navigation/carousel-cog-shooter.png";
import MartyJumpingSvg from "../../assets/games/marty-jumping.svg";
import CodewheelImg from "../../assets/games/codewheel.png";
import { ReactComponent as MartySkiRightSvg } from "../../assets/games/marty-ski-right.svg";
import MartyFly from "../../assets/games/marty-fly.png";
import TreeImg from "../../assets/games/tree.png";

import { ReactComponent as CogSvg } from "../../assets/games/cog.svg";

import { ReactComponent as MartyWaving } from "../../assets/games/marty-waving.svg";
import { useTranslation } from "react-i18next";

const baseImageStyle: React.CSSProperties = {
};

const imageStyleHeightAuto: React.CSSProperties = {
  ...baseImageStyle,
  height: "auto",
  width: "100%",
};

const imageStyleWidthAuto: React.CSSProperties = {
  ...baseImageStyle,
  height: "100%",
  width: "auto",
};

function GamesScreen() {
  const { t } = useTranslation();
  useEffect(() => {
    let stopHeartbeat: (() => void) | null = null;
    const logVisit = async () => {
      stopHeartbeat = await window.applicationManager.AnalyticsFacade.logScreenVisit(VisitedScreenEnum.GAMES);
    };
    logVisit();

    return () => {
      if (stopHeartbeat) {
        stopHeartbeat();
      }
    };
  }, []);

  const gamesGridContent: GridItemProps[] = [
    {
      id: 'jumping-game', title: t('games.jumping_game_title'),
      type: "game", contentTags: [RaftTypeE.COG], href: '/jumping-game',
      beforeNavigationCallback: () => {
        let isAnyCogConnected;
        for (const connectedRaftKey in window.applicationManager.connectedRafts) {
          if (window.applicationManager.connectedRafts[connectedRaftKey].type === RaftTypeE.COG) {
            isAnyCogConnected = true;
            break;
          }
        }
        if (!isAnyCogConnected) {
          window.applicationManager.toaster.info(t('games.connect_cog_first'));
          return false;
        }
        return true;
      },
      SvgIcon: () => <image href={MartyJumpingSvg} style={imageStyleWidthAuto} height={imageStyleWidthAuto.height} />,
      tags: ["Cog"]
    },
    {
      id: 'robofly-game', title: t('games.robofly_game_title'),
      type: "game", contentTags: [RaftTypeE.COG], href: '/robofly-game',
      beforeNavigationCallback: () => {
        let isAnyCogConnected;
        for (const connectedRaftKey in window.applicationManager.connectedRafts) {
          if (window.applicationManager.connectedRafts[connectedRaftKey].type === RaftTypeE.COG) {
            isAnyCogConnected = true;
            break;
          }
        }
        if (!isAnyCogConnected) {
          window.applicationManager.toaster.info(t('games.connect_cog_first'));
          return false;
        }
        return true;
      },
      SvgIcon: () => <image href={MartyFly} style={imageStyleHeightAuto} width={imageStyleHeightAuto.width} />,
      tags: ["Cog"]
    },
    {
      id: 'skiing-game', title: t('games.skiing_game_title'),
      type: "game", contentTags: [RaftTypeE.COG], href: '/skiing-game',
      beforeNavigationCallback: () => {
        let isAnyCogConnected;
        for (const connectedRaftKey in window.applicationManager.connectedRafts) {
          if (window.applicationManager.connectedRafts[connectedRaftKey].type === RaftTypeE.COG) {
            isAnyCogConnected = true;
            break;
          }
        }
        if (!isAnyCogConnected) {
          window.applicationManager.toaster.info(t('games.connect_cog_first'));
          return false;
        }
        return true;
      },
      SvgIcon: () => <MartySkiRightSvg style={imageStyleHeightAuto} width={imageStyleHeightAuto.width} />,
      tags: ["Cog"]
    },
    // {
    //   id: 'space-shooter', title: t('games.space_shooter_title'),
    //   type: "game", contentTags: [RaftTypeE.COG], href: '/space-shooter-game',
    //   SvgIcon: () => <image href={CarouselSpaceShooter} style={imageStyleHeightAuto} width={imageStyleHeightAuto.width} />,
    //   tags: ["Cog"]
    // },
    {
      id: 'cog-shooter', title: t('games.cog_shooter_title'),
      type: "game", contentTags: [RaftTypeE.COG], href: '/cog-shooter-game',
      SvgIcon: () => <image href={CarouselCogShooter} style={imageStyleHeightAuto} width={imageStyleHeightAuto.width} />,
      tags: ["Cog"]
    },
    {
      id: 'maze', title: t('games.maze_title'),
      type: "game", contentTags: [RaftTypeE.COG], href: '/maze',
      SvgIcon: () => <image href={CarouselMaze} style={imageStyleHeightAuto} width={imageStyleHeightAuto.width} />,
      tags: ["Cog"]
    },
    {
      id: 'codewheel', title: t('games.codewheel_title'),
      type: "game", contentTags: [RaftTypeE.COG], href: '/codewheel',
      SvgIcon: () => <image href={CodewheelImg} style={imageStyleHeightAuto} width={imageStyleHeightAuto.width} />,
      tags: ["Cog"]
    },
  ];

  return (
    <Layout>
      <div className={styles.projectsSectionContainer}>
        <h1 className={styles.projectsSectionTitle}>{t('games.blocks_builders_heading')}</h1>
        <MartyWaving className={styles.martyWavingImg} />
        <SequenceGridGames items={[...gamesGridContent]} />
        <img src={TreeImg} className={styles.treeImage} />
        <CogSvg className={styles.cogImg} />
      </div>
    </Layout>
  );
}

export default GamesScreen;
